if (!customElements.get('onten-best-sellers')) {
  customElements.define('onten-best-sellers', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('[data-filter-form]');
      this.grid = this.querySelector('[data-product-grid]');
      this.cards = Array.from(this.querySelectorAll('[data-product-card]'));
      this.limit = Number(this.dataset.pageSize) || 16;
      this.more = this.querySelector('[data-show-more]');
      this.count = this.querySelector('[data-result-count]');
      this.empty = this.querySelector('[data-empty]');
      this.error = this.querySelector('[data-price-error]');
      this.category = this.form.elements.ot_category;
      this.min = this.form.elements.ot_min;
      this.max = this.form.elements.ot_max;
      this.sort = this.form.elements.ot_sort;
      for (const option of Array.from(this.category.options).slice(1)) {
        if (!this.cards.some(card => card.dataset.categories.includes('|' + option.value + '|'))) option.remove();
      }
      this.readUrl();
      this.form.addEventListener('submit', event => event.preventDefault());
      this.form.addEventListener('change', () => { this.limit = 16; this.update(true); });
      this.form.addEventListener('input', event => {
        if (event.target.tagName === 'INPUT') { this.limit = 16; this.update(true); }
      });
      this.form.addEventListener('reset', () => requestAnimationFrame(() => { this.limit = 16; this.update(true); }));
      this.querySelector('[data-clear]').addEventListener('click', () => this.form.reset());
      this.more.addEventListener('click', () => { this.limit += 16; this.update(false); });
      this.onPopState = () => { this.readUrl(); this.limit = 16; this.update(false); };
      window.addEventListener('popstate', this.onPopState);
      this.update(false);
      const panel = this.querySelector('[data-filter-panel]');
      panel.open = window.matchMedia('(min-width: 990px)').matches;
      panel.hidden = false;
    }
    disconnectedCallback() { window.removeEventListener('popstate', this.onPopState); }
    readUrl() {
      const params = new URL(location.href).searchParams;
      this.category.value = params.get('ot_category') || '';
      if (!this.category.value) this.category.value = '';
      this.sort.value = params.get('ot_sort') || 'best';
      if (!this.sort.value) this.sort.value = 'best';
      for (const [key, input] of [['ot_min', this.min], ['ot_max', this.max]]) {
        const value = params.get(key);
        input.value = value !== null && Number.isFinite(Number(value)) && Number(value) >= 0 ? value : '';
      }
    }
    update(writeUrl) {
      const min = this.min.value === '' ? 0 : Math.max(0, Number(this.min.value)) * 100;
      const max = this.max.value === '' ? Infinity : Math.max(0, Number(this.max.value)) * 100;
      this.error.hidden = min <= max;
      const results = this.cards.filter(card => (!this.category.value || card.dataset.categories.includes('|' + this.category.value + '|')) && Number(card.dataset.price) >= min && Number(card.dataset.price) <= max);
      results.sort((a, b) => {
        if (this.sort.value === 'price-up') return Number(a.dataset.price) - Number(b.dataset.price);
        if (this.sort.value === 'price-down') return Number(b.dataset.price) - Number(a.dataset.price);
        if (this.sort.value === 'title') return a.dataset.title.localeCompare(b.dataset.title);
        return Number(a.dataset.rank) - Number(b.dataset.rank);
      });
      for (const card of this.cards) card.hidden = true;
      const fragment = document.createDocumentFragment();
      results.forEach((card, index) => { card.hidden = index >= this.limit; fragment.append(card); });
      this.grid.append(fragment);
      const visible = Math.min(this.limit, results.length);
      this.count.textContent = `Showing ${visible} of ${results.length} products`;
      this.empty.hidden = results.length !== 0;
      this.more.hidden = visible >= results.length;
      if (writeUrl) {
        const url = new URL(location.href);
        for (const [key, value] of [['ot_category', this.category.value], ['ot_min', this.min.value], ['ot_max', this.max.value], ['ot_sort', this.sort.value === 'best' ? '' : this.sort.value]]) {
          if (value) url.searchParams.set(key, value); else url.searchParams.delete(key);
        }
        history.replaceState(null, '', url);
      }
    }
  });
}
